import type { Rect } from '../../core';

/** Outer frame (viewBox plus margin) with the visible area cut out (even-odd fill). */
export const maskPath = (viewBox: Rect, visible: Rect, margin: number): string =>
  `M${viewBox.x - margin},${viewBox.y - margin}h${viewBox.width + margin * 2}v${viewBox.height + margin * 2}h${-viewBox.width - margin * 2}z` +
  `M${visible.x},${visible.y}h${visible.width}v${visible.height}h${-visible.width}z`;
